<template>
  <div class="d-flex items-center pt-10 pl-3 pr-3">
    <AccountResumeCardPage
      v-if="loadPath"
      shared-resume
      :load-path="loadPath"
    />
    <ErrorView v-else :code="400" title="Failed to load resume" />
  </div>
</template>

<script>
import AccountResumeCardPage from '../views/Account/AccountResumeCardPage';
import ErrorView from '../components/ErrorView';

export default {
  name: 'SharedVacancyPage',
  components: {
    ErrorView,
    AccountResumeCardPage,
  },
  computed: {
    sharedResumeHash() {
      return this.$route.params.sharedResumeHash;
    },
    loadPath() {
      if (!this.sharedResumeHash) return '';
      return `/api/new-resume/get-byhash?hash=${this.sharedResumeHash}`;
    },
  },
};
</script>
